<div fxLayout="row wrap">
    <p-checkbox label="Poligoni" [(ngModel)]="polygons" [binary]="true"></p-checkbox>
</div>
<div fxLayout="row wrap" style="margin-top: 0.5rem;">
    <p-checkbox label="Dati Catastali" [(ngModel)]="data" [binary]="true"></p-checkbox>
</div>
<div fxLayout="row wrap" style="margin-top: 0.5rem;">
    <p-checkbox label="Tabella Misurazioni" [(ngModel)]="table" [binary]="true"></p-checkbox>
</div>

<div fxLayout="row wrap" fxLayoutAlign="end center" style="margin-top: 0.5rem;">
    
    <button 
        fxFlex="27" 
        pButton 
        type="button" 
        (click)="onClose()"
        style="margin-right: 0.5rem; height: 35px; padding-top: 0.35rem;" 
        class="dialog-button">
        Annulla
    </button>
    <button 
        fxFlex="32" pButton type="button" 
        style="height: 35px; padding-top: 0.35rem;"
        class="dialog-button" 
        (click)="onConfirm()">
        Conferma
    </button>
</div>
